import React from 'react';
import { Helmet } from 'react-helmet';
import { PageHeader } from '@/components/layout/PageHeader';
import { EvaluatorsTab } from '@/components/evaluator/EvaluatorsTab';

const EvaluatorsPage: React.FC = () => (
  <>
    <Helmet>
      <title>Evaluators | Hobbes</title>
    </Helmet>
    <div className="flex min-h-0 flex-col">
      <PageHeader
        title="Evaluators"
        titleTooltip="Manage scoring criteria used to evaluate agent performance."
      />
      <div className="flex-1 px-4 pb-8 pt-5 sm:px-6 md:px-8">
        <EvaluatorsTab />
      </div>
    </div>
  </>
);

export default EvaluatorsPage;
